module.exports = __webpack_public_path__ + "img/broadcast-plug.19df1f61.jpg";